<template>
    <div>
        <form action=""></form>
            <h3 class="mt-2"><i class="fa fa-pencil-square-o"> </i><strong>Form</strong> Perizinan Barang Transit (Barang Kiriman)</h3>
            <b-card>
                <!-- <form @submit.prevent="submitAll" action=""> -->
                <b-card header="<i class='fa fa-user'></i> Identitas Diri">
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-fieldset label="Nama Ekspedisi">
                                <select @change="loadIdPerusahaan()" v-model="headerTransit.namaLengkap" v-validate="'required'" name="Nama Ekspedisi" id="" class="form-control">
                                    <option value=""></option>
                                    <option v-for="nama in dataPerusahaan" :value="nama.NAMA_PERUSAHAAN"> {{ nama.NAMA_PERUSAHAAN }} </option>
                                </select>
                                <small class="text-danger" v-show="errors.has('Nama Ekspedisi')"> {{ errors.first('Nama Ekspedisi') }} </small>
                            </b-form-fieldset>
                            <!-- <b-form-fieldset label="Nomor Identitas">
                                <input v-model="headerTransit.noIdentitas" type="text" class="form-control" disabled>
                            </b-form-fieldset>
                            <b-form-fieldset label="Alamat">
                                <input v-model="headerTransit.alamat" type="text" class="form-control" disabled>
                            </b-form-fieldset> -->
                            <b-form-fieldset label="Nama Kurir">
                                <input v-model="headerTransit.namaKurir" v-validate="'required'" name="Nama Kurir" type="text" class="form-control">
                                <small class="text-danger" v-show="errors.has('Nama Kurir')"> {{ errors.first('Nama Kurir') }} </small>
                            </b-form-fieldset>
                            <b-form-fieldset label="Kota Asal">
                                <!-- <input v-model="headerTransit.kotaAsal" v-validate="'required'" name="Kota Asal" type="text" class="form-control"> -->
                                <select v-model="headerTransit.kotaAsal" name="Kota Asal" id="" class="form-control">
                                  <option value=""></option>
                                  <option v-for="kota in refKota" :value="kota.NAMA_KOTA"> {{ kota.NAMA_KOTA }} </option>
                                </select>
                                <small class="text-danger" v-show="errors.has('Kota Asal')"> {{ errors.first('Kota Asal') }} </small>
                            </b-form-fieldset>
                            <b-form-fieldset label="Kota Tujuan">
                                <!-- <input v-model="headerTransit.kotaTujuan" v-validate="'required'" name="Kota Tujuan" type="text" class="form-control"> -->
                                <select v-model="headerTransit.kotaTujuan" name="Kota Tujuan" id="" class="form-control">
                                  <option value=""></option>
                                  <option v-for="kota in refKota" :value="kota.NAMA_KOTA"> {{ kota.NAMA_KOTA }} </option>
                                </select>
                                <small class="text-danger" v-show="errors.has('Kota Tujuan')"> {{ errors.first('Kota Tujuan') }} </small>
                            </b-form-fieldset>
                        </div>
                        <div class="col-md-6">
                            <b-form-fieldset label="Pelabuhan Kedatangan">
                                <select v-validate="'required'" v-model="headerTransit.pelKedatangan" name="PelKedatanganForm" id class="form-control">
                                    <option value></option>
                                    <option value="Batu Ampar">Batu Ampar</option>
                                    <option value="Warehouse Hang Nadim">Warehouse Hang Nadim</option>
                                    <option value="Terminal Hang Nadim">Terminal Hang Nadim</option>
                                    <option value="Telaga Punggur">Telaga Punggur</option>
                                    <option value="Roro Punggur">Roro Punggur</option>
                                    <option value="Domestik Sekupang">Domestik Sekupang</option>
                                    <option value="Harbour Bay">Harbour Bay</option>
                                    <option value="Nongsa Pura">Nongsa Pura</option>
                                    <option value="Batam Center">Batam Center</option>
                                </select>
                                <small class="text-danger" v-show="errors.has('PelKedatanganForm')"> {{ errors.first('PelKedatanganForm') }} </small>
                            </b-form-fieldset>
                            <b-form-fieldset label="Pelabuhan Keberangkatan">
                                <select v-validate="'required'" v-model="headerTransit.pelKeberangkatan" name="PelKeberangkatanform" id class="form-control">
                                    <option value></option>
                                    <option value="Batu Ampar">Batu Ampar</option>
                                    <option value="Warehouse Hang Nadim">Warehouse Hang Nadim</option>
                                    <option value="Terminal Hang Nadim">Terminal Hang Nadim</option>
                                    <option value="Telaga Punggur">Telaga Punggur</option>
                                    <option value="Roro Punggur">Roro Punggur</option>
                                    <option value="Domestik Sekupang">Domestik Sekupang</option>
                                    <option value="Harbour Bay">Harbour Bay</option>
                                    <option value="Nongsa Pura">Nongsa Pura</option>
                                    <option value="Batam Center">Batam Center</option>
                                </select>
                                <small class="text-danger" v-show="errors.has('PelKeberangkatanform')"> {{ errors.first('PelKeberangkatanform') }} </small>
                            </b-form-fieldset>
                            <b-form-fieldset label="Tanggal Perkiraan Pengeluaran">
                                <input v-validate="'required'" name="Tanggal Perkiraan" v-model="headerTransit.tglPerkiraan" type="date" locale="en" class="form-control">
                                <small class="text-danger" v-show="errors.has('Tanggal Perkiraan')"> {{ errors.first('Tanggal Perkiraan') }} </small>
                            </b-form-fieldset>
                        </div>
                    </div>
                </b-card>
                <b-card header="<i class='fa fa-cube'></i> Data Kemasan">
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-fieldset label="Jumlah Kemasan">
                                <input v-model="headerTransit.jumlahKemasan" v-validate="'required'" name="Jumlah Kemasan" type="number" class="form-control">
                                <small class="text-danger" v-show="errors.has('Jumlah Kemasan')"> {{ errors.first('Jumlah Kemasan') }} </small>
                            </b-form-fieldset>
                        </div>
                        <div class="col-md-6">
                            <b-form-fieldset label="Jenis Kemasan">
                                <!-- <input v-model="headerTransit.jenisKemasan" v-validate="'required'" name="Jenis Kemasan" type="text" class="form-control"> -->
                                <select v-model="headerTransit.jenisKemasan" v-validate="'required'" name="Jenis Kemasan" id="" class="form-control">
                                  <option value=""></option>
                                  <option v-for="kemasan in refKemasan" :value="kemasan.JNS_KMS"> {{ kemasan.JNS_KMS }} - {{ kemasan.UR_KMS }} </option>
                                </select>
                                <small class="text-danger" v-show="errors.has('Jenis Kemasan')"> {{ errors.first('Jenis Kemasan') }} </small>
                            </b-form-fieldset>
                        </div>
                    </div>
                </b-card>
                <b-card header="<i class='fa fa-cube'></i> Data Barang">
                    <div class="row">
                        <div class="col-md-10">
                            <p><i class="fa fa-th-list"></i> List Barang</p>
                        </div>
                        <div class="col-md-1">
                            <button @click="deleteAll" class="btn btn-danger pull-left"><i class="fa fa-trash-o"></i> Delete All</button>
                        </div>
                        <div class="col-md-1">
                            <button v-b-toggle.collapse-add class="btn btn-primary"><i class="fa fa-plus"></i> Add</button>
                        </div>
                    </div>
                    <div class="mt-4">
                    <table class="table table-bordered table-responsive">
                        <thead>
                            <tr>
                                <th width="1%" scope="col">No</th>
                                <th width="" scope="col">Nama Pesawat</th>
                                <th width="15%" scope="col">Nomor Penerbangan</th>
                                <th width="15%" scope="col">Nomor SMU</th>
                                <th width="9%" scope="col">Jumlah</th>
                                <th width="9%" scope="col">Berat</th>
                                <th width="12%%" scope="col">Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(data,index) in headerTransit.tableDetail" :key="index">
                                <td> {{ index + 1 }} </td>
                                <td> {{ data.namaPesawat }} </td>
                                <td> {{ data.noPenerbangan }} </td>
                                <td> {{ data.noSmu }} </td>
                                <td> {{ data.jumlahBarang }} {{ data.satuanBarang }} </td>
                                <td> {{ data.berat }} kg </td>
                                <td>
                                    <button @click="deleteGoods" class="btn btn-danger" title="delete"><i class="fa fa-trash-o"></i></button>
                                    <button v-b-toggle="`collapse-edit ${index}`" class="btn btn-secondary" title="edit"><i class="fa fa-edit"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                    <!-- collapse input -->
                    <div>
                        <b-collapse id="collapse-add" class="mt-2">
                            <b-card header="<i class='fa fa-edit'></i> Tambah Barang">
                                <div class="row">
                                  <div class="col-6">
                                    <!-- <input v-model="detailTransit.namaPesawat" type="text" class="form-control" placeholder="Nama Pesawat"> -->
                                    <div class="row">
                                      <div class="col-11">
                                          <b-form-fieldset>
                                              <select v-model="detailTransit.namaPesawat" name="Nama Sarkut" id="" class="form-control">
                                                  <option value="">Nama Pesawat / Kapal</option>
                                                  <option v-for="nama in refSarkut" :value="nama.nama_sarkut"> {{ nama.nama_sarkut }} </option>
                                              </select>
                                          </b-form-fieldset>
                                      </div>
                                      <div class="col-1">
                                          <b-form-fieldset>
                                              <button v-b-modal.tambah-kapal class="btn btn-success" title="Tambah Nama Pesawat / Kapal"><i class="fa fa-plus"></i></button>
                                          </b-form-fieldset>
                                      </div>
                                  </div>
                                  </div>
                                  <div class="col-6">
                                    <input v-model="detailTransit.noPenerbangan" type="text" class="form-control" placeholder="Nomor Penerbangan">
                                  </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-3">
                                        <input v-model="detailTransit.noSmu" class="form-control" placeholder="No. SMU">
                                    </div>
                                    <div class="col-md-3">
                                        <input type="number" v-model="detailTransit.jumlahBarang" class="form-control" placeholder="Jumlah Barang">
                                    </div>
                                    <div class="col-md-3">
                                        <input v-model="detailTransit.satuanBarang" class="form-control" placeholder="Satuan Barang">
                                    </div>
                                    <div class="col-md-3">
                                        <input v-model="detailTransit.berat" class="form-control" placeholder="Berat (kg)">
                                    </div>
                                </div>
                                <div class="row">
                                  <div class="col-12">
                                    <div class="mt-3 pull-right">
                                        <button @click="submitGoods" v-b-toggle.collapse-add class="btn btn-primary"><i class="fa fa-save"></i> Save</button>
                                        <button v-b-toggle.collapse-add class="btn btn-danger"><i class="fa fa-times"></i> Cancel</button>
                                    </div>
                                  </div>
                                </div>
                            </b-card>
                        </b-collapse>
                    </div>
                    <!-- collapse input end -->
                    <!-- collapse edit -->
                    <div>
                        <b-collapse v-for="(data,index) in headerTransit.tableDetail" :key="index" :id="`collapse-edit ${index}`" class="mt-2">
                            <b-card :header="`<i class='fa fa-edit'></i> Edit Barang ${index+1} `">
                                <div class="row">
                                  <div class="col-6">
                                    <b-form-fieldset label="Nama Pesawat">
                                      <!-- <input v-model="detailTransit.namaPesawat" :placeholder="data.namaPesawat" class="form-control"> -->
                                      <div class="row">
                                        <div class="col-11">
                                          <select v-model="detailTransit.namaPesawat" name="Nama Sarkut" id="" class="form-control">
                                              <option value="">Nama Pesawat / Kapal</option>
                                              <option v-for="nama in refSarkut" :value="nama.nama_sarkut"> {{ nama.nama_sarkut }} </option>
                                          </select>
                                        </div>
                                        <div class="col-1">
                                          <b-form-fieldset>
                                              <button v-b-modal.tambah-kapal class="btn btn-success" title="Tambah Nama Pesawat / Kapal"><i class="fa fa-plus"></i></button>
                                          </b-form-fieldset>
                                        </div>
                                      </div>
                                    </b-form-fieldset>
                                  </div>
                                  <div class="col-6">
                                    <b-form-fieldset label="Nomor Penerbangan">
                                      <input v-model="detailTransit.noPenerbangan" :placeholder="data.noPenerbangan" type="text" class="form-control">
                                    </b-form-fieldset>
                                  </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-3">
                                        <b-form-fieldset label="Nomor SMU">
                                            <input v-model="detailTransit.noSmu" :placeholder="data.noSmu" class="detail form-control">
                                        </b-form-fieldset>
                                    </div>
                                    <div class="col-md-3">
                                        <b-form-fieldset label="Jumlah Barang">
                                            <input v-model="detailTransit.jumlahBarang" :placeholder="data.jumlahBarang" class="detail form-control">
                                        </b-form-fieldset>
                                    </div>
                                    <div class="col-md-3">
                                        <b-form-fieldset label="Satuan Barang">
                                            <input v-model="detailTransit.satuanBarang" :placeholder="data.satuanBarang" class="detail form-control" type="text">
                                        </b-form-fieldset>
                                    </div>
                                    <div class="col-md-3">
                                        <b-form-fieldset label="Berat (kg)">
                                            <input v-model="detailTransit.berat" :placeholder="data.berat" class="detail form-control">
                                        </b-form-fieldset>
                                    </div>
                                </div>
                                <div class="mt-3 pull-right">
                                    <button @click="saveEdit(index)" v-b-toggle="`collapse-edit ${index}`" class="btn btn-primary"><i class="fa fa-save"></i> Save</button>
                                    <button v-b-toggle="`collapse-edit ${index}`" class="btn btn-danger"><i class="fa fa-times"></i> Cancel</button>
                                </div>
                            </b-card>
                        </b-collapse>
                    </div>
                    <!-- collapse edit end -->
                </b-card>
                <div class="row justify-content-between">
                    <div class="col-6">
                        <router-link :to="'/login'">
                            <button class="btn btn-default btn-lg"><i class="fa fa-times"></i> Cancel</button>
                        </router-link>
                    </div>
                    <div class="col-6">
                        <button @click="submitAll" class="btn btn-primary btn-lg pull-right"><i class="fa fa-paper-plane"></i> Send</button>
                    </div>
                </div>
                <b-modal v-model="modalRefSarkut" hide-footer id="tambah-kapal" title="Tambah Nama Pesawat / Kapal">
                    <b-form-fieldset label="Nama Pesawat / Kapal">
                        <input type="text" class="form-control" v-model="tambahRefSarkut.nama" style="text-transform: uppercase;">
                        <button @click="addNamaSarkut()" class="btn btn-primary pull-right mt-2">Tambah</button>
                    </b-form-fieldset>
                </b-modal>
            <!-- </form> -->
            </b-card>
    </div>
</template>

<script>
import swal from 'sweetalert'
export default {
  data () {
    return {
      headerTransit: {
        namaLengkap: '',
        noIdentitas: '',
        alamat: '',
        pekerjaan: '',
        namaSarkut: '',
        noBl: '',
        pelKedatangan: '',
        pelKeberangkatan: '',
        jenisTransit: 'Barang Kiriman',
        tglPerkiraan: '',
        jumlahKemasan: '',
        jenisKemasan: '',
        kotaAsal: '',
        kotaTujuan: '',
        namaKurir: '',
        tableDetail: []
      },
      detailTransit: {
        uraianBarang: '',
        typeMerk: '',
        noSeri: '',
        jumlahBarang: '',
        satuanBarang: '',
        berat: '',
        noSmu: '',
        namaPesawat: '',
        noPenerbangan: ''
      },
      pelTransit: [],
      dataPerusahaan: [],
      idPerusahaan: [],
      getKode: '',
      refKota: [],
      refSarkut: [],
      tambahRefSarkut: {
        nama: ''
      },
      refKemasan: [],
      modalRefSarkut: false
    }
  },
  created () {
    this.loadPerusahaan()
    this.loadKota()
    this.loadNamaSarkut()
    this.loadKemasan()
  },
  methods: {
    submitAll () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http.post('storeTransit', this.headerTransit).then(response => {
            this.$router.push('/resulttransit/' + response.data.kd_regis)
          })
        }
      })
    },
    submitGoods () {
      this.headerTransit.tableDetail.push({
        noSmu: this.detailTransit.noSmu,
        uraianBarang: this.detailTransit.uraianBarang,
        typeMerk: this.detailTransit.typeMerk,
        noSeri: this.detailTransit.noSeri,
        jumlahBarang: this.detailTransit.jumlahBarang,
        satuanBarang: this.detailTransit.satuanBarang,
        berat: this.detailTransit.berat,
        namaPesawat: this.detailTransit.namaPesawat,
        noPenerbangan: this.detailTransit.noPenerbangan
      })
      this.clearField()
    },
    deleteGoods (index) {
      this.headerTransit.tableDetail.splice(index, 1)
    },
    deleteAll (index) {
      this.headerTransit.tableDetail.splice(index)
    },
    clearField () {
      this.detailTransit.noSmu = ''
      this.detailTransit.uraianBarang = ''
      this.detailTransit.typeMerk = ''
      this.detailTransit.noSeri = ''
      this.detailTransit.jumlahBarang = ''
      this.detailTransit.satuanBarang = ''
      this.detailTransit.berat = ''
      this.detailTransit.namaPesawat = ''
      this.detailTransit.noPenerbangan = ''
    },
    openForm () {
      var inputs = document.getElementsByClassName('detail')
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].disabled = false
      }
    },
    closeForm () {
      var inputs = document.getElementsByClassName('detail')
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].disabled = true
      }
    },
    saveEdit (index) {
      if (this.detailTransit.noSmu !== '') {
        this.headerTransit.tableDetail[index].noSmu = this.detailTransit.noSmu
      }
      if (this.detailTransit.uraianBarang !== '') {
        this.headerTransit.tableDetail[index].uraianBarang = this.detailTransit.uraianBarang
      }
      if (this.detailTransit.typeMerk !== '') {
        this.headerTransit.tableDetail[index].typeMerk = this.detailTransit.typeMerk
      }
      if (this.detailTransit.noSeri !== '') {
        this.headerTransit.tableDetail[index].noSeri = this.detailTransit.noSeri
      }
      if (this.detailTransit.jumlahBarang !== '') {
        this.headerTransit.tableDetail[index].jumlahBarang = this.detailTransit.jumlahBarang
      }
      if (this.detailTransit.satuanBarang !== '') {
        this.headerTransit.tableDetail[index].satuanBarang = this.detailTransit.satuanBarang
      }
      if (this.detailTransit.berat !== '') {
        this.headerTransit.tableDetail[index].berat = this.detailTransit.berat
      }
      if (this.detailTransit.namaPesawat !== '') {
        this.headerTransit.tableDetail[index].namaPesawat = this.detailTransit.namaPesawat
      }
      if (this.detailTransit.noPenerbangan !== '') {
        this.headerTransit.tableDetail[index].noPenerbangan = this.detailTransit.noPenerbangan
      }
      this.clearField()
    },
    loadPelabuhan () {
      this.$http.get('pelTransit')
        .then(response => {
          this.pelTransit = response.data
        })
    },
    loadPerusahaan () {
      this.$http.get('transit/load/perusahaan')
        .then(response => {
          this.dataPerusahaan = response.data
        })
    },
    loadIdPerusahaan () {
      this.$http.get('transit/load/perusahaan/' + this.headerTransit.namaLengkap)
        .then(response => {
          this.headerTransit.noIdentitas = response.data.ID_PERUSAHAAN
          this.headerTransit.alamat = response.data.AL_PERUSAHAAN
        })
    },
    loadKota () {
      this.$http.get('transit/load/kota').then(response => {
        this.refKota = response.data
      })
    },
    loadNamaSarkut () {
      this.$http.get('transit/load/namaSarkut').then(response => {
        this.refSarkut = response.data
      })
    },
    addNamaSarkut () {
      if (this.tambahRefSarkut.nama !== '') {
        var data = {
          nama: this.tambahRefSarkut.nama.toUpperCase()
        }
        this.$http.post('transit/load/namaSarkut', data).then(response => {
          if (response) {
            swal({
              title: 'SUCCESS',
              text: 'Data Berhasil Disimpan',
              icon: 'success',
              buttons: {
                Yes: 'Yes'
              }
            })
          }
          this.loadNamaSarkut()
        })
        this.modalRefSarkut = false
        this.tambahRefSarkut.nama = ''
      } else {
        swal('error', 'ISIAN TIDAK BOLEH KOSONG', 'error')
      }
    },
    loadKemasan () {
      this.$http.get('transit/load/kemasan').then(response => {
        this.refKemasan = response.data
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/transit/FormTransitA.vue?6cb52654